import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';

export const CreateNewContract: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { createNewContract } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepCreateNewContract">
      <h3>{t('manageContracts:manageContracts.CreateNewContractTitle')}*</h3>

      <p>{t('manageContracts:manageContracts.CreateNewContractBody')}</p>

      <div className="form-items">
        <ManageContractsRadio
          radioID="manageContractsCreateNewContractYes"
          radioName="manageContractsCreateNewContract"
          onChangeFunc={(): void => {
            dispatch(['newContract', true]);
            dispatch(['newAddressUseCurrentAddress', false]);
          }}
          checkedComparison={createNewContract === true}
          label={`${t('manageContracts:manageContracts.CreateNewContractYes')}`}
        />

        <ManageContractsRadio
          radioID="manageContractsCreateNewContractNo"
          radioName="manageContractsCreateNewContract"
          onChangeFunc={(): void => dispatch(['newContract', false])}
          checkedComparison={createNewContract === false}
          label={`${t('manageContracts:manageContracts.CreateNewContractNo')}`}
        />
      </div>
    </section>
  );
};

export default CreateNewContract;
